import React, { useState } from 'react';
import styled from 'styled-components';
import {
    BUTTON_CONTENT_BASE,
    CONTENT_DISABLED,
    CONTENT_BASE,
    PRIMARY_BASE,
    PRIMARY_MUTED
} from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

type IconProps = {
    selected: boolean;
};

const IconWrapper = styled.div<{ selected: boolean; }>`
    display: flex;
    width: 32px;
    height: 32px;
    padding: 8px;
    justify-content: center;
    align-items: center;

    border-radius: 100px;
    border: ${({ selected }) => selected ? `1px solid ${PRIMARY_BASE}` : `1px solid ${CONTENT_DISABLED}`};
    background: ${({ selected }) => selected ? PRIMARY_BASE : BUTTON_CONTENT_BASE};

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const ThumbsUpIcon: React.FC<IconProps> = ({ selected }) => {
    const [hovered, setHovered] = useState(false);

    return (
        <IconWrapper
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            selected={selected}
        >
            {selected ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                   <title>{translated('Accessibility.SvgTitle.thumbsUpIcon')}</title>
                    <g id='thumbs_up_on (ea50)'>
                        <g id='^ Name above ^'>
                            <path
                                d='M13.5492 6.67729C14.1622 6.67729 14.6597 7.17408 14.6597 7.78785C14.6597 8.18321 14.4524 8.52748 14.1415 8.72442C14.2333 8.88582 14.2896 9.06944 14.2896 9.2686C14.2896 9.66321 14.0822 10.0082 13.7713 10.2052C13.8631 10.3658 13.9194 10.5502 13.9194 10.7493C13.9194 11.144 13.7121 11.489 13.4011 11.6859C13.4929 11.8466 13.5492 12.0309 13.5492 12.2301C13.5492 12.8431 13.0516 13.3407 12.4386 13.3407H5.77525V6.67729C5.77525 6.67729 7.256 6.58474 7.256 5.19654V3.98759C7.256 3.22236 7.72536 2.69705 8.34288 2.66871C8.96039 2.64037 9.56786 3.00622 9.70541 5.01698C9.70541 5.66703 9.66073 6.31006 9.61409 6.67729H13.5492Z'
                                fill={PRIMARY_MUTED}
                            />
                            <path
                                d='M5.03488 6.67729H1.33301V12.9705C1.33301 13.1748 1.49885 13.3407 1.70319 13.3407H5.03488V6.67729Z'
                                fill={PRIMARY_MUTED}
                            />
                        </g>
                    </g>
                </svg>
            ) : hovered ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <title>{translated('Accessibility.SvgTitle.thumbsUpIcon')}</title>
                    <g id='thumbs_up_on (ea50)'>
                        <g id='^ Name above ^'>
                            <path
                                d='M13.5492 6.67729C14.1622 6.67729 14.6597 7.17408 14.6597 7.78785C14.6597 8.18321 14.4524 8.52748 14.1415 8.72442C14.2333 8.88582 14.2896 9.06944 14.2896 9.2686C14.2896 9.66321 14.0822 10.0082 13.7713 10.2052C13.8631 10.3658 13.9194 10.5502 13.9194 10.7493C13.9194 11.144 13.7121 11.489 13.4011 11.6859C13.4929 11.8466 13.5492 12.0309 13.5492 12.2301C13.5492 12.8431 13.0516 13.3407 12.4386 13.3407H5.77525V6.67729C5.77525 6.67729 7.256 6.58474 7.256 5.19654V3.98759C7.256 3.22236 7.72536 2.69705 8.34288 2.66871C8.96039 2.64037 9.56786 3.00622 9.70541 5.01698C9.70541 5.66703 9.66073 6.31006 9.61409 6.67729H13.5492Z'
                                fill={CONTENT_BASE}
                            />
                            <path
                                d='M5.03488 6.67729H1.33301V12.9705C1.33301 13.1748 1.49885 13.3407 1.70319 13.3407H5.03488V6.67729Z'
                                fill={CONTENT_BASE}
                            />
                        </g>
                    </g>
                </svg>
            ) : (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                    <title>{translated('Accessibility.SvgTitle.thumbsUpIcon')}</title>
                    <g id='thanks_neighborhoods (e9f1)'>
                        <path
                            id='^ Name above ^'
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M5.03741 6.6694H1.33496L1.33496 13.3365C1.33496 13.3365 4.64811 13.3365 5.03741 13.3365L5.03741 6.6694ZM2.00014 12.6667H4.95317V7.3516H2.00014V12.6667ZM13.4533 8.60453C13.4533 8.60453 13.7611 9.05576 13.6749 9.41431C13.6004 9.72445 13.0505 9.97795 13.0505 9.97795C13.0505 9.97795 13.2828 10.39 13.26 10.719C13.2318 11.1259 12.7525 11.4158 12.7525 11.4158C12.7525 11.4158 13.0075 11.7656 12.9755 12.0612C12.9435 12.3567 12.7577 12.667 12.2358 12.667H5.62515V7.2832C6.68097 7.14995 8.10092 6.53188 8.10092 5.20004V3.79952C8.10092 3.56842 8.17569 3.34175 8.37931 3.34175C9.34386 3.22765 9.38758 4.47516 9.41048 4.92114C9.46598 6.00237 9.2822 6.80086 9.23408 7.15815H13.0102C13.5856 7.14062 13.9564 7.43051 14.0023 7.8125C14.0596 8.28906 13.4533 8.60453 13.4533 8.60453ZM14.6415 7.57343C14.5052 6.88138 13.7111 6.48441 13.1563 6.48441H10.0231C10.0942 5.92816 10.0942 5.52188 10.0942 4.85158C10.0271 3.00635 9.0704 2.63642 8.37931 2.6667C7.84136 2.69027 7.42158 3.13285 7.42158 3.77347V5.09379C7.42158 6.63545 5.03741 6.6694 5.03741 6.6694L5.03741 13.3365H12.1403C13.0596 13.3365 13.5624 12.8333 13.633 12.0858C13.6523 11.8814 13.633 11.7422 13.5674 11.5781C13.9162 11.2436 13.9737 10.6875 13.8796 10.2407C14.2966 9.9401 14.4554 9.28125 14.2699 8.80659C14.6415 8.49176 14.7159 7.95159 14.6415 7.57343Z'
                            fill={CONTENT_BASE}
                        />
                    </g>
                </svg>
            )}
        </IconWrapper>
    );
};
